import React from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

function ProtectedRoute({ children, feature = 'esta funcionalidade', onUnauthorized }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-lg mx-4">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
        <Lock className="w-8 h-8 text-red-600" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Acesso Restrito</h3>
      <p className="text-gray-600 text-center mb-6 max-w-md">
        Você foi redirecionado para {feature} sem autenticação. Por favor, volte e faça login para continuar.
      </p>
      <button
        onClick={onUnauthorized}
        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      >
        Voltar ao Início
      </button>
    </div>
  );
}

export default ProtectedRoute;
